import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { EnvironmentProvider } from './environment-provider.service';
import { GoogleAnalyticsClient } from './google-analytics-client.service';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(
    private location: Location,
    private router: Router,
    private googleAnalyticsClient: GoogleAnalyticsClient,
    private environmentProvider: EnvironmentProvider,
  ) {
  }

  initTracking(): void {
    if (!this.isProduction()) {
      return;
    }

    this.googleAnalyticsClient.create();
    this.trackPageViews();
  }

  trackPageViews(): void {
    if (!this.isProduction()) {
      return;
    }

    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
    ).subscribe(() => {
      this.googleAnalyticsClient.sendPageView(this.location.path());
    });
  }

  /**
   * @param category Typically the object that was interacted with
   * @param action   The type of interaction
   * @param [label]  Useful for categorizing events
   * @param [value]  A numeric value associated with the event
   */
  trackEvent(category: string, action: string, label?: string, value?: number): void {
    if (!this.isProduction()) {
      return;
    }

    this.googleAnalyticsClient.sendEvent(category, action, label, value);
  }

  private isProduction(): boolean {
    const environment = this.environmentProvider.get();

    return environment.envName === 'prod';
  }
}
